export default "__VITE_ASSET__C5ON5TpE__"